import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ShutdownPage } from './shutdown-page';

const root = createRoot(document.getElementById('root')!);

root.render(
  <StrictMode>
    <ShutdownPage />
  </StrictMode>
);
